import { isMiniApp } from './platform';

export interface ZaloSubmissionGrant {
  miniapp: true;
  zaloAccessToken?: string;
  zaloOaUserId?: string;
}
let pending: Promise<ZaloSubmissionGrant> | undefined;
export async function readZaloSubmissionGrant(): Promise<ZaloSubmissionGrant> {
  if (!isMiniApp()) throw new Error('Vui lòng mở Mini App trong Zalo để gửi yêu cầu.');
  if (!pending) {
    const request = (async () => {
      const { getSetting, authorize, getUserInfo, getAccessToken } = await import('zmp-sdk');
      try {
        const { authSetting } = await getSetting({});
        if (authSetting['scope.userInfo'] !== true) {
          const granted = await authorize({ scopes: ['scope.userInfo'] });
          if (granted['scope.userInfo'] !== true) return { miniapp: true as const };
        }
        const { userInfo } = await getUserInfo({ autoRequestPermission: false });
        const zaloOaUserId = userInfo?.idByOA;
        const zaloAccessToken = await getAccessToken({});
        return {
          miniapp: true as const,
          ...(typeof zaloOaUserId === 'string' && /^\d{1,40}$/.test(zaloOaUserId) ? { zaloOaUserId } : {}),
          ...(typeof zaloAccessToken === 'string' && zaloAccessToken ? { zaloAccessToken } : {}),
        };
      } catch {
        return { miniapp: true as const };
      }
    })();
    pending = request;
    // A timeout cannot dismiss a native consent dialog. Keep the real request
    // pending so another activation cannot stack a second dialog.
    void request.then(() => { if (pending === request) pending = undefined; }, () => { if (pending === request) pending = undefined; });
  }
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([pending, new Promise<never>((_, reject) => {
      timer = setTimeout(() => reject(new Error('ZALO_CONNECT_TIMEOUT')), 45_000);
    })]);
  } catch {
    // Consent is optional. The consultation can be stored without an OA link.
    return { miniapp: true };
  } finally { clearTimeout(timer); }
}
export function useZaloSubmission() {
  return { grant: readZaloSubmissionGrant };
}
export function OpenZaloForSubmission() {
  return <section className="zalo-submission-gate">
    <h2>Gửi yêu cầu qua Zalo</h2>
    <p>Để gửi yêu cầu, vui lòng mở Mini App và kết nối tài khoản Zalo của bạn.</p>
    <a className="button" href="https://zalo.me/s/4585387948520694413/">Mở Mini App Zalo</a>
  </section>;
}
